export default function Heading({ children }) {
  return <h2 className="text-lg font-bold text-gray-500">{children}</h2>;
}
